import { useTranslation } from 'react-i18next';

import { Card } from '@/components/ui/card';
import { TopItemsList } from '@/features/dashboard-charts';
import type { TopItemsData } from '@/entities/dashboard';

import { InfoHint } from './info-hint';

interface TopListsGridProps {
  topProducts?: TopItemsData;
  topServiceUsers?: TopItemsData;
  isLoading: boolean;
}

export function TopListsGrid({ topProducts, topServiceUsers, isLoading }: TopListsGridProps) {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <Card className="gap-3 p-4">
        <h3 className="flex items-center gap-1.5 text-base font-semibold">
          {t('welcome.chart.topwarehousesprodcat.label')}
          <InfoHint text={t('welcome.chart.topwarehousesprodcat.desc')} />
        </h3>
        <TopItemsList data={topProducts} loading={isLoading} />
      </Card>

      <Card className="gap-3 p-4">
        <h3 className="flex items-center gap-1.5 text-base font-semibold">
          {t('welcome.chart.topusers.label')}
          <InfoHint text={t('welcome.chart.topusers.desc')} />
        </h3>
        <TopItemsList data={topServiceUsers} loading={isLoading} />
      </Card>
    </div>
  );
}
